import React, { useState } from "react";
import T from '../../components/common/T';
import DataTable from "../../components/common/DataTables.jsx";
import TableActionButtons from "../../components/common/TableActionButtons";
import PageHeader from "../../components/common/PageHeader";
import Price from "../../components/common/Price";
import { TrashIcon } from "@heroicons/react/24/outline";


const AssetListView = ({ assets, onDetails, onEdit, onDelete, getStatusBadge }) => {
  const [selectedAssets, setSelectedAssets] = useState([]);

  const handleDeleteSelected = async (clearSelection) => {
    if (window.confirm(`Delete ${selectedAssets.length} selected assets?`)) {
      for (const id of selectedAssets) {
        await onDelete(id);
      }
      clearSelection();
    }
  };

  const columns = [
    {
      header: "Asset Name",
      accessor: "name",
      sortable: true,
      render: (asset) => (
        <div>
          <div className="font-semibold text-gray-900">{asset.name}</div>
          {asset.project_name && (
            <div className="text-[10px] text-blue-600 mt-0.5 flex items-center gap-1">
              📍 {asset.project_name}
            </div>
          )}
        </div>
      )
    },
    {
      header: "Serial / Code",
      accessor: "code",
      sortable: true,
      render: (asset) => (
        <span className="font-mono text-[11px] text-gray-600 bg-gray-100 px-1.5 py-0.5 rounded border border-gray-200">
          {asset.code || "N/A"}
        </span>
      )
    },
    { header: "Category", accessor: "category", sortable: true },
    {
      header: "Status",
      accessor: "status",
      sortable: true,
      align: "center",
      render: (asset) => getStatusBadge(asset.status)
    },
    {
      header: "Location",
      accessor: "location",
      render: (asset) => (
        asset.current_project_id ? (
          <span className="text-blue-600 font-medium bg-blue-50 px-1.5 py-0.5 rounded text-[10px] border border-blue-100">
            On Site
          </span>
        ) : (
          <span className="text-gray-500">{asset.location || "Warehouse"}</span>
        )
      )
    },
    {
      header: "Cost Rate",
      accessor: "cost_rate",
      sortable: true,
      align: "right",
      render: (asset) => (
        <div>
          <span className="font-semibold text-purple-600"><Price amount={asset.cost_rate || 0} /></span>
          <span className="text-gray-400 text-[10px]">/hr</span>
        </div>
      )
    },
    {
      header: "Actions",
      align: "right",
      render: (asset) => (
        <TableActionButtons
          onView={() => onDetails(asset)}
          onEdit={() => onEdit(asset.id)}
          onDelete={() => onDelete(asset.id)}
        />
      )
    }
  ];

  return (
    <DataTable
      data={assets}
      columns={columns}
      emptyMessage="No assets found."
      selectable={true}
      selectedIds={selectedAssets}
      onSelectionChange={setSelectedAssets}
      renderBulkActions={({ clearSelection }) => (
        <div className="flex gap-2">
          <button
            onClick={() => handleDeleteSelected(clearSelection)}
            className="px-3 py-1 bg-red-100 text-red-700 border border-red-200 rounded hover:bg-red-200 transition text-[11px] font-semibold flex items-center gap-1"
          >
            <TrashIcon className="w-3 h-3" />
            Delete Selected
          </button>
          <button
            onClick={clearSelection}
            className="px-3 py-1 bg-white text-gray-700 rounded hover:bg-gray-50 transition text-[11px] font-medium border border-gray-300"
          >
            Clear Selection
          </button>
        </div>
      )}
    />
  );
};

export default AssetListView;